export default "__VITE_ASSET__BdhOxYQy__"